
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/purchases/track",
      function () {
        return require("private-next-pages/purchases/track.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/purchases/track"])
      });
    }
  